import styled from 'styled-components';

type EmbedSizeProps = {
  height?: string | number;
  width?: string | number;
};

export type EmbedVideoProps = {
  url: string;
} & EmbedSizeProps;

export const EmbedVideo = ({ url, ...rest }: EmbedVideoProps) => {
  let id = getYoutubeId(url);
  if (id) return <YouTubeEmbed id={id} {...rest} />;

  id = getVimeoId(url);
  if (id) return <VimeoEmbed id={id} {...rest} />;

  return null;
};

const youtubeUrlRegex = new RegExp(
  /\/youtube.com\/embed\/(\w+)\/?|youtube.com\/watch\?v=((\w|-|_)+)/
);
const vimeoUrlRegex = new RegExp(/\/vimeo.com\/(\d+)\/?/);

const getVimeoId = (url: string) => {
  const match = vimeoUrlRegex.exec(url);
  if (!match) return;

  return match[1];
};

const getYoutubeId = (url: string) => {
  const match = youtubeUrlRegex.exec(url);
  if (!match) return;

  return match[1] || match[2];
};

type EmbedImplProps = {
  id: string;
} & EmbedSizeProps;

const VimeoEmbed = ({ id, width = '100%', height = 240 }: EmbedImplProps) => {
  return (
    <FrameContainer>
      <iframe
        width={width}
        height={height}
        src={`https://player.vimeo.com/video/${id}`}
        allowFullScreen
        title="Vimeo video"
      />
    </FrameContainer>
  );
};

const YouTubeEmbed = ({ id, height = 241, width = 432 }: EmbedImplProps) => {
  return (
    <FrameContainer>
      <iframe
        width={width}
        height={height}
        src={`https://www.youtube.com/embed/${id}`}
        allowFullScreen
        title="YouTube video"
      />
    </FrameContainer>
  );
};
const FrameContainer = styled.div({
  overflow: 'hidden',
  iframe: {
    border: 'none',
  },
});
